!function (t, o) {
  "object" == typeof exports && "object" == typeof module ? module.exports = o() : "function" == typeof define && define.amd ? define([], o) : "object" == typeof exports ? exports["@hotmart/cosmos"] = o() : t["@hotmart/cosmos"] = o();
}(self, function () {
  return (() => {
    "use strict";

    var t = {
        7705: t => {
          t.exports = function (t) {
            var o = [];
            return o.toString = function () {
              return this.map(function (o) {
                var e = "",
                  r = void 0 !== o[5];
                return o[4] && (e += "@supports (".concat(o[4], ") {")), o[2] && (e += "@media ".concat(o[2], " {")), r && (e += "@layer".concat(o[5].length > 0 ? " ".concat(o[5]) : "", " {")), e += t(o), r && (e += "}"), o[2] && (e += "}"), o[4] && (e += "}"), e;
              }).join("");
            }, o.i = function (t, e, r, a, i) {
              "string" == typeof t && (t = [[null, t, void 0]]);
              var n = {};
              if (r) for (var s = 0; s < this.length; s++) {
                var l = this[s][0];
                null != l && (n[l] = !0);
              }
              for (var c = 0; c < t.length; c++) {
                var p = [].concat(t[c]);
                r && n[p[0]] || (void 0 !== i && (void 0 === p[5] || (p[1] = "@layer".concat(p[5].length > 0 ? " ".concat(p[5]) : "", " {").concat(p[1], "}")), p[5] = i), e && (p[2] ? (p[1] = "@media ".concat(p[2], " {").concat(p[1], "}"), p[2] = e) : p[2] = e), a && (p[4] ? (p[1] = "@supports (".concat(p[4], ") {").concat(p[1], "}"), p[4] = a) : p[4] = "".concat(a)), o.push(p));
              }
            }, o;
          };
        },
        6738: t => {
          t.exports = function (t) {
            return t[1];
          };
        },
        5097: (t, o, e) => {
          e.d(o, {
            Z: () => s
          });
          var r = e(6738),
            a = e.n(r),
            i = e(7705),
            n = e.n(i)()(a());
          n.push([t.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
          const s = n;
        },
        5031: (t, o, e) => {
          e.d(o, {
            Z: () => s
          });
          var r = e(6738),
            a = e.n(r),
            i = e(7705),
            n = e.n(i)()(a());
          n.push([t.id, ":host{display:inline-block}", ""]);
          const s = n;
        },
        5445: (t, o, e) => {
          e.d(o, {
            Z: () => s
          });
          var r = e(6738),
            a = e.n(r),
            i = e(7705),
            n = e.n(i)()(a());
          n.push([t.id, ':host(.fade){opacity:0;pointer-events:none;-webkit-transition:opacity 500ms cubic-bezier(0.2, 1, 0.2, 1) 0ms;-o-transition:opacity 500ms cubic-bezier(0.2, 1, 0.2, 1) 0ms;-moz-transition:opacity 500ms cubic-bezier(0.2, 1, 0.2, 1) 0ms;transition:opacity 500ms cubic-bezier(0.2, 1, 0.2, 1) 0ms;-webkit-transition:opacity var(--timing) var(--easing) 0ms;-o-transition:opacity var(--timing) var(--easing) 0ms;-moz-transition:opacity var(--timing) var(--easing) 0ms;transition:opacity var(--timing) var(--easing) 0ms}:host(.fade.show){opacity:1;pointer-events:all}.hot-tooltip__inner{background-color:var(--gray-900, #191c1f);-webkit-border-radius:var(--border-radius, 0.25rem);-moz-border-radius:var(--border-radius, 0.25rem);border-radius:var(--border-radius, 0.25rem);-webkit-box-shadow:var(--box-shadow, 0 8px 16px -6px rgba(0, 0, 0, 0.12));-moz-box-shadow:var(--box-shadow, 0 8px 16px -6px rgba(0, 0, 0, 0.12));box-shadow:var(--box-shadow, 0 8px 16px -6px rgba(0, 0, 0, 0.12));color:var(--gray-100, #f7f9fa);display:none;max-width:var(--tooltip-max-width, 12rem);padding:var(--spacer-2, 0.5rem) var(--spacer-4, 1rem);text-align:left;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host{display:block;font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol");font-size:var(--text-1, 0.75rem);font-style:normal;font-weight:var(--font-weight-bold, 700);letter-spacing:normal;line-break:auto;line-height:var(--line-height-lg, 1.5);margin:0;opacity:0;position:absolute;text-align:left;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:break-word;z-index:1060}:host .arrow{display:block;height:var(--spacer-2, 0.5rem);position:absolute;width:var(--spacer-3, 0.75rem)}:host .arrow::before{border-color:transparent;border-style:solid;content:"";position:absolute}:host .hot-tooltip__inner{display:block}:host(.hot-tooltip--top){padding:var(--tooltip-padding, 0.5rem) 0}:host(.hot-tooltip--top) .arrow{bottom:0;left:50%;margin-left:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:calc(var(--tooltip-border-width, 0.0625rem)*-1);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%)}:host(.hot-tooltip--top) .arrow::before{border-top-color:var(--gray-900, #191c1f);border-width:var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem) 0;top:0}:host(.hot-tooltip--right){padding:0 var(--tooltip-padding, 0.5rem)}:host(.hot-tooltip--right) .arrow{height:var(--spacer-3, 0.75rem);left:var(--tooltip-border-width, 0.0625rem);margin-top:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:calc(var(--tooltip-border-width, 0.0625rem)*-1);top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);width:var(--spacer-2, 0.5rem)}:host(.hot-tooltip--right) .arrow::before{border-right-color:var(--gray-900, #191c1f);border-width:var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem) 0;right:0}:host(.hot-tooltip--bottom){padding:var(--tooltip-padding, 0.5rem) 0}:host(.hot-tooltip--bottom) .arrow{left:50%;margin-left:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:calc(var(--tooltip-border-width, 0.0625rem)*-1);top:0;-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%)}:host(.hot-tooltip--bottom) .arrow::before{border-bottom-color:var(--gray-900, #191c1f);border-width:0 var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem);bottom:0}:host(.hot-tooltip--left){padding:0 var(--tooltip-padding, 0.5rem)}:host(.hot-tooltip--left) .arrow{height:var(--spacer-3, 0.75rem);margin-top:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:calc(var(--tooltip-border-width, 0.0625rem)*-1);right:var(--tooltip-border-width, 0.0625rem);top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);width:var(--spacer-2, 0.5rem)}:host(.hot-tooltip--left) .arrow::before{border-left-color:var(--gray-900, #191c1f);border-width:var(--spacer-2, 0.5rem) 0 var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem);left:0}:host(.hot-tooltip--auto[position^=top]){padding:var(--tooltip-padding, 0.5rem) 0}:host(.hot-tooltip--auto[position^=top]) .arrow{bottom:0;left:50%;margin-left:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:calc(var(--tooltip-border-width, 0.0625rem)*-1);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%)}:host(.hot-tooltip--auto[position^=top]) .arrow::before{border-top-color:var(--gray-900, #191c1f);border-width:var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem) 0;top:0}:host(.hot-tooltip--auto[position^=right]){padding:0 var(--tooltip-padding, 0.5rem)}:host(.hot-tooltip--auto[position^=right]) .arrow{height:var(--spacer-3, 0.75rem);left:var(--tooltip-border-width, 0.0625rem);margin-top:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:calc(var(--tooltip-border-width, 0.0625rem)*-1);top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);width:var(--spacer-2, 0.5rem)}:host(.hot-tooltip--auto[position^=right]) .arrow::before{border-right-color:var(--gray-900, #191c1f);border-width:var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem) 0;right:0}:host(.hot-tooltip--auto[position^=bottom]){padding:var(--tooltip-padding, 0.5rem) 0}:host(.hot-tooltip--auto[position^=bottom]) .arrow{left:50%;margin-left:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-left:calc(var(--tooltip-border-width, 0.0625rem)*-1);top:0;-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%)}:host(.hot-tooltip--auto[position^=bottom]) .arrow::before{border-bottom-color:var(--gray-900, #191c1f);border-width:0 var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem);bottom:0}:host(.hot-tooltip--auto[position^=left]){padding:0 var(--tooltip-padding, 0.5rem)}:host(.hot-tooltip--auto[position^=left]) .arrow{height:var(--spacer-3, 0.75rem);margin-top:-webkit-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:-moz-calc(var(--tooltip-border-width, 0.0625rem)*-1);margin-top:calc(var(--tooltip-border-width, 0.0625rem)*-1);right:var(--tooltip-border-width, 0.0625rem);top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);width:var(--spacer-2, 0.5rem)}:host(.hot-tooltip--auto[position^=left]) .arrow::before{border-left-color:var(--gray-900, #191c1f);border-width:var(--spacer-2, 0.5rem) 0 var(--spacer-2, 0.5rem) var(--spacer-2, 0.5rem);left:0}', ""]);
          const s = n;
        }
      },
      o = {};
    function e(r) {
      var a = o[r];
      if (void 0 !== a) return a.exports;
      var i = o[r] = {
        id: r,
        exports: {}
      };
      return t[r](i, i.exports, e), i.exports;
    }
    e.n = t => {
      var o = t && t.__esModule ? () => t.default : () => t;
      return e.d(o, {
        a: o
      }), o;
    }, e.d = (t, o) => {
      for (var r in o) e.o(o, r) && !e.o(t, r) && Object.defineProperty(t, r, {
        enumerable: !0,
        get: o[r]
      });
    }, e.o = (t, o) => Object.prototype.hasOwnProperty.call(t, o), e.r = t => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return (() => {
      e.r(r);
      const t = require("@babel/runtime/helpers/classCallCheck");
      var o = e.n(t);
      const a = require("@babel/runtime/helpers/createClass");
      var i = e.n(a);
      const n = require("@babel/runtime/helpers/assertThisInitialized");
      var s = e.n(n);
      const l = require("@babel/runtime/helpers/get");
      var c = e.n(l);
      const p = require("@babel/runtime/helpers/inherits");
      var h = e.n(p);
      const d = require("@babel/runtime/helpers/possibleConstructorReturn");
      var m = e.n(d);
      const f = require("@babel/runtime/helpers/getPrototypeOf");
      var u = e.n(f);
      const v = require("@babel/runtime/helpers/wrapNativeSuper");
      var b = e.n(v),
        g = e(5097);
      const w = function (t) {
        h()(n, t);
        var e,
          r,
          a = (e = n, r = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              o = u()(e);
            if (r) {
              var a = u()(this).constructor;
              t = Reflect.construct(o, arguments, a);
            } else t = o.apply(this, arguments);
            return m()(this, t);
          });
        function n(t) {
          var e;
          o()(this, n);
          var r = (e = a.call(this)).getTemplate(),
            i = document.createElement("template");
          i.innerHTML = r;
          var s = i.content.querySelector("style");
          return s && (s.innerHTML = "".concat(s.innerHTML, " ").concat(g.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(i, t), e.attachShadow({
            mode: "open"
          }), e.shadowRoot.appendChild(document.importNode(i.content, !0)), e;
        }
        return i()(n, [{
          key: "connectedCallback",
          value: function () {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "";
          }
        }]), n;
      }(b()(HTMLElement));
      function y(t, o) {
        customElements.get(t) || customElements.define(t, o);
      }
      var _ = "hot-tooltip",
        k = "disabled",
        x = "content",
        S = e(5031),
        z = e(5445);
      var E = "hot-tooltip-concrete";
      y(E, function (t) {
        h()(n, t);
        var e,
          r,
          a = (e = n, r = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              o = u()(e);
            if (r) {
              var a = u()(this).constructor;
              t = Reflect.construct(o, arguments, a);
            } else t = o.apply(this, arguments);
            return m()(this, t);
          });
        function n() {
          return o()(this, n), a.call(this, E);
        }
        return i()(n, [{
          key: "attributeChangedCallback",
          value: function (t, o, e) {
            t === x && this._handleContent(e);
          }
        }, {
          key: "_handleContent",
          value: function (t) {
            this.shadowRoot.querySelector(".hot-tooltip__inner").innerHTML = t;
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "\n      <style>".concat(z.Z.toString(), '</style>\n      <div class="arrow"></div>\n      <div class="hot-tooltip__inner"></div>\n    ');
          }
        }], [{
          key: "observedAttributes",
          get: function () {
            return [x];
          }
        }]), n;
      }(w)), y(_, function (t) {
        h()(n, t);
        var e,
          r,
          a = (e = n, r = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              o = u()(e);
            if (r) {
              var a = u()(this).constructor;
              t = Reflect.construct(o, arguments, a);
            } else t = o.apply(this, arguments);
            return m()(this, t);
          });
        function n() {
          var t;
          return o()(this, n), (t = a.call(this, _))._tooltip = null, t._onMouseEnter = t._onMouseEnter.bind(s()(t)), t._onMouseLeave = t._onMouseLeave.bind(s()(t)), t._updatePlacement = t._updatePlacement.bind(s()(t)), t;
        }
        return i()(n, [{
          key: "disabled",
          get: function () {
            return this.hasAttribute(k);
          },
          set: function (t) {
            t ? this.setAttribute(k) : this.removeAttribute(k);
          }
        }, {
          key: "position",
          get: function () {
            return this.getAttribute("position") || "top";
          },
          set: function (t) {
            this.setAttribute("position", t);
          }
        }, {
          key: "attributeChangedCallback",
          value: function (t) {
            t === k && this.disabled && this._onMouseLeave();
          }
        }, {
          key: "connectedCallback",
          value: function () {
            c()(u()(n.prototype), "connectedCallback", this).call(this), window.addEventListener("scroll", this._updatePlacement), this.addEventListener("mouseenter", this._onMouseEnter), this.addEventListener("mouseleave", this._onMouseLeave);
          }
        }, {
          key: "disconnectedCallback",
          value: function () {
            window.removeEventListener("scroll", this._updatePlacement), this.removeEventListener("mouseenter", this._onMouseEnter), this.removeEventListener("mouseleave", this._onMouseLeave), this._tooltip && this._tooltip.parentNode.removeChild(this._tooltip);
          }
        }, {
          key: "_createTooltip",
          value: function () {
            var t = this.getAttribute("content");
            if (!t || this.disabled) return null;
            var o = document.createElement("hot-tooltip-concrete");
            return o.classList.add("hot-tooltip--".concat(this.position)), o.classList.add("fade"), o.setAttribute("content", t), o;
          }
        }, {
          key: "_onMouseEnter",
          value: function () {
            this._tooltip && (this._tooltip.parentNode.removeChild(this._tooltip), this._tooltip = null), this._tooltip = this._createTooltip(), this._tooltip && (document.body.appendChild(this._tooltip), this._updatePlacement(), this._tooltip.classList.add("show"));
          }
        }, {
          key: "_onMouseLeave",
          value: function () {
            var t = this;
            this._tooltip && (this._toggleAnimationEvent(this._tooltip, "addEventListener", function o() {
              t._tooltip && (t._toggleAnimationEvent(t._tooltip, "removeEventListener", o), t._tooltip.parentNode.removeChild(t._tooltip), t._tooltip = null);
            }), this._tooltip.classList.remove("show"));
          }
        }, {
          key: "_updatePlacement",
          value: function () {
            if (this._tooltip) {
              var t = this.getBoundingClientRect();
              "left" === this.position && (this._tooltip.style.top = "".concat(t.top + window.pageYOffset + t.height / 2 - this._tooltip.offsetHeight / 2, "px"), this._tooltip.style.left = "".concat(t.left - this._tooltip.offsetWidth, "px")), "right" === this.position && (this._tooltip.style.top = "".concat(t.top + window.pageYOffset + t.height / 2 - this._tooltip.offsetHeight / 2, "px"), this._tooltip.style.left = "".concat(t.left + t.width, "px")), "top" === this.position && (this._tooltip.style.top = "".concat(t.top + window.pageYOffset - this._tooltip.offsetHeight, "px"), this._tooltip.style.left = "".concat(t.left + t.width / 2 - this._tooltip.offsetWidth / 2, "px")), "bottom" === this.position && (this._tooltip.style.top = "".concat(t.top + window.pageYOffset + t.height, "px"), this._tooltip.style.left = "".concat(t.left + t.width / 2 - this._tooltip.offsetWidth / 2, "px"));
            }
          }
        }, {
          key: "_toggleAnimationEvent",
          value: function (t, o, e) {
            t[o]("webkitTransitionEnd", e), t[o]("oTransitionEnd", e), t[o]("msAnimationEnd", e), t[o]("transitionend", e);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "\n      <style>".concat(S.Z.toString(), "</style>\n      <slot></slot>\n    ");
          }
        }], [{
          key: "observedAttributes",
          get: function () {
            return [k];
          }
        }]), n;
      }(w));
    })(), r;
  })();
});